import _ from "lodash";

import ColorUtil from "./ColorUtil";
import { OrgInfoStore } from "@/stores/OrgInfoStore";

export default class PlaceUtil {
    static getBaseUnitId(subunitId) {
        return subunitId.split("_")[0];
    }

    static getPlaceLabel(place) {
        const overrideLabel = _.get(place, "overrides.label");
        if (overrideLabel !== undefined && overrideLabel !== null) {
            return overrideLabel;
        }
        return _.get(place, "mapObject.address.number", "N/A");
    }

    static getOtherAddresses(places, place) {
        return _.get(places, _.get(place, "mapObject.id"));
        // const otherAddresses = new Set();
        // if (place.parentId !== null && place.parentId !== undefined) {
        //     const parent = _.get(places, place.parentId);
        //     _.forEach(parent.subunits, (subunit) => otherAddresses.add(subunit));
        //     otherAddresses.add(place.parentId);
        // } else {
        //     _.forEach(place.subunits, (subunit) => otherAddresses.add(subunit));
        //     otherAddresses.add(_.get(place, "mapObject.id"));
        // }

        // // TODO ignore undefined entries
        // return _.map([...otherAddresses], (id) => _.get(places, id));
    }

    static getMarkerHtml(places, placeId, selectedId = undefined, editMode = false) {
        const place = _.get(places, placeId);
        if (place === undefined) {
            return;
        }

        // const otherPlaces = PlaceUtil.getOtherAddresses(places, place);
        let labelsAndResponses = _.map([place], (otherPlace) => {
            return {
                label: PlaceUtil.getPlaceLabel(otherPlace),
                abbreviation: _.get(otherPlace, "responseCode.abbreviation", "NR"),
                id: _.get(otherPlace, "mapObject.id")
            }
        });
        labelsAndResponses = _.sortBy(labelsAndResponses, "label");

        const clazz = editMode === true ? "parcel-address-edit-mode" : undefined;
        return _.map(labelsAndResponses, (value) => PlaceUtil.getPlaceMarker(value.label, value.abbreviation, value.id === selectedId, clazz)).join('');
    }

    static getPlaceMarker(label, responseAbbreviation, _, clazz = undefined) {
        let style = `style="color:${PlaceUtil.responseToColor(responseAbbreviation)};"`
        let classValue = (clazz !== undefined) ? `class="${clazz}"` : "";
        return `<div ${style} ${classValue}><b>${label}</b> ${responseAbbreviation}</div>`;
    }

    static responseToColor(place) {
        const orgColor = _.get(OrgInfoStore.responseCodeColors, place);
        if (orgColor) {
            return ColorUtil.ensureReadable(orgColor);
        }
        switch (place) {
            case "NR":
                return "#37474F";
            case "OK":
                return "#2E7D32";
            case "C":
                return "#F57C00";
            default:
                return "#37474F";
        }
    }

    static responseToPolygonFill(place) {
        switch (place) {
            case "NR":
                return "#FFFFFF";
            case "OK":
                return "#4CAF50";
            case "C":
                return "#FFEB3B";
            default:
                return "#BDBDBD";
        }
    }

    static responseToHoverFill(place) {
        return ColorUtil.adjust(this.responseToPolygonFill(place), -30);
    }
}